export interface EventEntryInput extends EventInformation, CommercialVehiclRestrictions {}

export const MajorEventTimeToLiveInDays = 7;

export interface EventInformation {
  id: string;
  contacts: Contact[];
  contractNumber: string;
  counties: County[];
  createdBy: string;
  createdDate: string;
  endDate: string;
  eventName: string;
  geometry?: GeoJSON.Geometry;
  isMajorEvent: boolean;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
  locations: Location[];
  projectNotes: string;
  region: Region;
  startDate: string;
  status: EventStatus;
  TimeToLive?: Number;
  trafficImpacts: TrafficImpact[];
  type: EventType;
  updateLog: UpdateLog[];
}

export interface Contact {
  name: string;
  priPhone?: string;
  altPhone?: string;
  email?: string;
  title?: string;
}

export interface Location {
  commonName?: string;
  direction?: RoadwayDirection;
  endMilepost?: number;
  startMilepost?: number;
  stateRoute?: string;
}

export interface TrafficImpact extends Location {
  comments: string;
  contingencyStartDate: string;
  contingencyEndDate: string;
  endDate: string;
  endTime: string;
  geometry?: GeoJSON.Geometry;
  isContinuous: boolean;
  isWeatherPermitting: boolean;
  priority: string;
  status: EventStatus;
  startDate: string;
  startTime: string;
  trafficControlRequired: string; // common strings
  type: TrafficImpactType; // todo: rename field to trafficImpactType ?
  workDays: string[]; // day of week
  workDescription: string;
}

export interface CommercialVehiclRestrictions {
  time?: string;
  person?: string;
  text?: string;
}

// For log of updates
export interface UpdateLog {
  time: string;
  personal: string;
  text: string;
}

// from WZDB
export enum County {}

// from WZDB
// This is the UI display order. So don't sort them alphabetically.
export enum Region {
  Eastern = "Eastern",
  North_Central = "North Central",
  Northwest = "Northwest",
  Olympic = "Olympic",
  South_Central = "South Central",
  Southwest = "Southwest",
}

// This is the UI display order. So don't sort them alphabetically.
export enum RoadwayDirection {
  Northbound = "Northbound",
  Southbound = "Southbound",
  Westbound = "Westbound",
  Eastbound = "Eastbound",
  Both_Directions = "Both Directions",
}

// todo: Add more / find the other instance of this set of values
export enum TrafficControlType {
  ShortTermRampClosures = "Short Term Ramp Closures",
}

// aka, WorkZoneType
// This is the UI display order. So don't sort them alphabetically.
export enum EventType {
  Contract = "Contract",
  Maintenance = "Maintenance",
  Special_Event = "Special Event", // from WZDB
  Utilities = "Utilities",
  Other = "Other",
}

// This is the UI display order. So don't sort them alphabetically.
export enum TrafficImpactType {
  OnRamp = "On Ramp",
  OffRamp = "Off Ramp",
  Center = "Center",
  Shoulder = "Shoulder",
  SingleLane = "Single Lane",
  DoubleLaneClosure = "Double Lane Closure",
  FullClosure = "Full Closure",
  RightLane = "Right Lane",
  TwoRightLanes = "2 Right Lanes",
  ThreeLeftLanes = "3 Left Lanes",
  LeftLane = "Left Lane",
  TwoLeftLanes = "2 Left Lanes",
  ThreeRightLanes = "3 Right Lanes",
  FourLeftLanes = "4 Left Lanes",
  FlaggingOperation = "Flagging Operation",
  FlaggingDividedHighway = "Flagging - Divided Highway",
  FlaggingIntersection = "Flagging - Intersection",
}

export enum EventStatus {
  Active = "Active",
  Pending = "Pending",
}
